import React from "react";
import RightHighlightedArrow from "../../../assets/images/icons/rgt_arrow_vector.png";
import { AIEnabledTabImages, imagePaths } from "../../../constants";
import { useSearchParams } from "react-router-dom";

const AITab = ({ onBtnClick }) => {
  const [_, setSearchParams] = useSearchParams();

  const handleTryAI = () => {
    // this will merge into your current URL
    const baseUrl = window.location.origin;
    window.location.href = `${baseUrl}/metalcloud`;
  };

  return (
    <div className={`metal-cloud-container`}>
      <div className="display-section">
        {AIEnabledTabImages.slice(0, AIEnabledTabImages?.length / 2).map(
          ({ text, icon }, idx) => {
            return (
              <div key={idx} className="displayBoxes AITabDisplayBoxes">
                <img src={icon} alt="" loading="lazy" />
                <p>{text}</p>
              </div>
            );
          }
        )}
      </div>
      <div className="mid-section">
        <div className="mid-header">
          Your Entire Shop Floor on
          <br/>
          <span className="skyText">
            <strong>One AI Execution System</strong>
          </span>
        </div>
        <div onClick={handleTryAI} className="ai-tab-btn">
          <button>Try AI for Your Factory</button>
          <img src={RightHighlightedArrow} alt="" loading="lazy" />
        </div>
        <div className="image-section ai-img-section">
          <img src={imagePaths.AIMainImage} alt="" loading="lazy" />
        </div>
      </div>

      <div className="display-section">
        {AIEnabledTabImages.slice(AIEnabledTabImages?.length / 2).map(
          ({ text, icon }, idx) => {
            return (
              <div key={idx} className="displayBoxes AITabDisplayBoxes">
                <img src={icon} alt="" loading="lazy" />
                <p>{text}</p>
              </div>
            );
          }
        )}
      </div>
      <div className={`mobileDisplaySection equallyDistributedGrid`}>
        {AIEnabledTabImages.map(({ text, icon, alignment = "column" }, idx) => {
          return (
            <div
              key={idx}
              style={{
                flexDirection: alignment,
              }}
              className="displayBoxes AITabDisplayBoxes"
            >
              <img src={icon} alt="" loading="lazy" />
              <p>{text}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AITab;
